import { createContext, useContext } from "react";
import { Transaction } from "../../types/Transaction";
import { ClassifiedTransactions } from "../../types/classifiedTransactions";
// Ensure that setTransactions is included in the TransactionContextValues type
export type TransactionContextValues = {
  transactions: Transaction[];// Add this line if it's missing

  loadingStatus: string,
  isValidating: boolean,
  refetch: () => void, // Change from () => {} to () => void
  error: any, // Change from null to any to allow any type of error object
  mutate: () => void,
  classifiedTransactions: ClassifiedTransactions,
  ctLoadingStatus: string,
  ctIsValidating: boolean,
  ctRefetch: () => void,
  ctError: any,
  ctMutate: () => void,
};

export const TransactionContext = createContext<TransactionContextValues>({
  transactions: [], // Provide a default implementation
  loadingStatus: "initial",
  isValidating: false,
  refetch: () => {},
  error: null,
  mutate: () => {},
  classifiedTransactions: [],
  ctLoadingStatus: "initial",
  ctIsValidating: false,
  ctRefetch: () => {},
  ctError: null,
  ctMutate: () => {},
});


export const useTransactionContext = () => useContext(TransactionContext);
